import React from 'react';
import SupportChatModuleTagsTable from './SupportChatModuleTagsTable';

const SupportChatModuleTags = () => (
  <div>
    <SupportChatModuleTagsTable />
  </div>
);

export default SupportChatModuleTags;
